import TipoPendencia from "@pages/TipoPendencia/TipoPendencia";

export default TipoPendencia;
